import { Component } from 'react';
import Page from '../../containers/page';

import {
    Button,
    Container,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../components/listBuilder';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../helpers/linkHelper';
import { API_ENDPOINT } from '../../constants';
import { formValueSelector, change } from 'redux-form';  // ES6
import { connect } from 'react-redux';
import viewIcon from '../../assets/svg/eye.svg';

import { JOURNAL_API } from '../../constants';
import DatePicker from '../../components/forms/fields/datePicker';
import InfoModal from '../../components/infoModal';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
class JournalLogs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            useState: false,
            params: {
                entries: 10,
                page: 0
            },
            journalNotes: [],
            // startDateLogs: new Date().getTime() / 1000,
            // endDateLogs: new Date().getTime() / 1000,
        };
    }


    get = async () => {
        this.setState({
            loading: true,
            journalNotes: [],
            modified: 'Not modified'.translate(this.props.lang),
        });

        try {
            const params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
            let startDate = false;
            let endDate = false;
            if (this.state.startDateLogs) {
                const d = new Date(this.state.startDateLogs);
                d.setUTCHours(0, 0, 0, 0);
                startDate = d.getTime();
            }

            if (this.state.endDateLogs) {
                const d = new Date(this.state.endDateLogs);
                d.setUTCHours(23, 59, 59, 999);
                endDate = d.getTime();
            }
            const response = await fetch(
                `${API_ENDPOINT}/users/users/patient/journal-logs`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                        entries: Number(params?.entries),
                        page: Number(params?.page),
                        doctorName: this.state.filterDoctorName || null,
                        patientName: this.state.filterPatientName || null,
                        username: this.state.filterUsername || null,
                        patientSSN: this.state.filterPatientSSN || null,
                        startDate: startDate,
                        endDate: endDate,
                    }),
                }
            );

            const { data } = await response.json();

            let dataObj = data.data

            if (dataObj?.items) {
                const newState = {
                    loading: false,
                    journalNotes: dataObj?.items,
                    total: dataObj?.total,
                };

                if (dataObj?.tsModified) {
                    const modified = this.props.getStringDateTs?.(
                        dataObj?.tsModified,
                        this.props.dateFormat
                    );
                    if (modified) newState.modified = modified.translate(this.props.lang);
                }

                this.setState(newState);
            } else {
                const errState = {
                    loading: false,
                    modified: 'Not modified'.translate(this.props.lang),
                };

                if (dataObj?.error) {
                    errState.error = dataObj.error;
                }

                this.setState(errState);
            }
        } catch (err) {
            this.setState({
                loading: false,
                error: err?.message || 'Error fetching journal notes',
            });
        }
    }

    componentDidMount() {
        this.get();
    }

    componentWillUnmount() {
        clearTimeout(this._filterDebounce);
    }

    componentDidUpdate(prevProps, prevState) {
        const condition = (
            (prevState.filterDoctorName !== this.state.filterDoctorName) ||
            (prevState.filterPatientName !== this.state.filterPatientName) ||
            (prevState.filterUsername !== this.state.filterUsername) ||
            (prevState.filterPatientSSN !== this.state.filterPatientSSN) ||
            (prevState.startDateLogs !== this.state.startDateLogs) ||
            (prevState.endDateLogs !== this.state.endDateLogs)
        );


        if (condition) {
            clearTimeout(this._filterDebounce);
            this._filterDebounce = setTimeout(() => {
                this.setState({ loading: true }, () => {
                    this.get();
                });
            }, 200);
        }

        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.selectedClinic != this.props.selectedClinic) {
            this.get();
        }

    }

    exportConsentLogs = () => {
        let startDate = false;
        let endDate = false;
        if (this.state.startDateLogs) {
            const d = new Date(this.state.startDateLogs);
            d.setUTCHours(0, 0, 0, 0);
            startDate = d.getTime();
        }

        if (this.state.endDateLogs) {
            const d = new Date(this.state.endDateLogs);
            d.setUTCHours(23, 59, 59, 999);
            endDate = d.getTime();
        }

        this.setState({
            loadingExport: true
        }, () => {
            fetch(`${API_ENDPOINT}/users/users/patient/journal-logs/export`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    },
                    body: JSON.stringify({
                        groupId: this.props.selectedGroup || null,
                        lang: this.props.lang,
                        doctorName: this.state.filterDoctorName || null,
                        patientName: this.state.filterPatientName || null,
                        username: this.state.filterUsername || null,
                        patientSSN: this.state.filterPatientSSN || null,
                        startDate: startDate,
                        endDate: endDate,
                    }),
                }
            ).then(res => res.json()).then(result => {
                let setObj = { loadingExport: false, exportModal: false };
                if (result?.exportData?._id && result?.exportData?.fileName) {
                    setObj.exportFileData = {
                        _id: result.exportData._id,
                        fileName: result.exportData.fileName,
                        message: `${"Your export is being prepared. You can download it from the Group statistics page on tab EHR logs once it's ready.".translate(this.props.lang)}`
                    }
                }
                this.setState(setObj)
            }).catch(() => {
                this.setState({ exportModal: false, loadingExport: false })
            })
        })

        // if (!res.ok) {
        //     const text = await res.text().catch(() => "");
        //     throw new Error(`Export failed (${res.status}): ${text}`);
        // }

        // const blob = await res.blob();

        // // Try to read filename from Content-Disposition
        // const cd = res.headers.get("content-disposition") || "";
        // const match = cd.match(/filename\*?=(?:UTF-8''|")?([^;"\n]+)"?/i);
        // const filename = match ? decodeURIComponent(match[1]) : "logs.xlsx";

        // const url = window.URL.createObjectURL(blob);
        // const a = document.createElement("a");
        // a.href = url;
        // a.download = filename;
        // document.body.appendChild(a);
        // a.click();
        // a.remove();
        // window.URL.revokeObjectURL(url);

    }

    updateSort = (field, type) => {
        if (this.state.useState) {
            let state = this.state.params;
            state.sortField = field;
            state.sortType = type;
            this.setState({
                params: state
            })
        } else {
            this.props[0].history.push(
                generateSearchLinkMultiple(
                    this.props[0].location.search,
                    { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 },
                    [
                        {
                            name: 'sortField', value: field
                        }
                        ,
                        {
                            name: 'sortType', value: type
                        }
                    ],
                    false));

        }
    }


    updateParams = (name, value, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                obj[name] = value;
                this.setState({ params: obj });
            } else {
                let obj = this.state.params;
                obj[name] = value;
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLink(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 }, name, value, restart));
        }
    }
    updateMultipleParams = (fields, restart = false) => {
        if (this.state.useState) {
            if (restart) {
                let obj = {
                    entries: 10,
                    page: 0
                };
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj });

            } else {
                let obj = this.state.params;
                for (let i = 0; i < fields.length; i++) {
                    obj[fields[i].name] = fields[i].value;
                }
                this.setState({ params: obj })
            }
        } else {
            this.props[0].history.push(generateSearchLinkMultiple(this.props[0].location.search, { entries: 10, page: 0, sortField: 'timestamp', sortType: -1 }, fields, restart));
        }
    }

    render() {
        let params = {};
        if (this.state.useState) {
            params = this.state.params;
        } else {
            params = getSearchParams(this.props[0].location.search, { entries: 10, page: 0 })
        }

        const humanReadable = {
            'patient_lab_results': 'Patient Lab Results'.translate(this.props.lang),
            'patient_documents': 'Patient Documents'.translate(this.props.lang),
            'patient_health_flags': 'Patient Health Flags'.translate(this.props.lang),
            'patients': 'Patients'.translate(this.props.lang),
            'patient_diagnoses': 'Patient Diagnoses'.translate(this.props.lang),
            'patient_notes': 'Patient Notes'.translate(this.props.lang),
            'patient_vaccination': 'Patient Vaccination'.translate(this.props.lang),
            'patient_vital_logs': 'Patient Vital Logs'.translate(this.props.lang),
        }

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>



                <Container fluid>
                    <Row>
                        <div className='panel'>

                            <div className="panel-header" >
                                {/* <h5 className="component-header" style={{ whiteSpace: 'nowrap' }}>{'EHR Logs'.translate(this.props.lang)}</h5> */}
                                <h5 className="component-header mb-35">{this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}</h5>

                                <Button color='primary' onClick={() => {
                                    this.setState({
                                        exportModal: true
                                    })
                                }}>{'Export'.translate(this.props.lang)}</Button>
                            </div>

                            <ListBuilder
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                hideEntries={false}
                                hideFilters={true}
                                showNumeration={false}
                                customFilters={
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: 20, width: '80%' }}>

                                            <FormGroup>
                                                <Label>{'Doctor name'.translate(this.props.lang)}</Label>
                                                <Input value={this.state.filterDoctorName} onChange={(e) => {
                                                    this.setState({
                                                        filterDoctorName: e.target.value
                                                    })
                                                }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'Patient name'.translate(this.props.lang)}</Label>
                                                <Input value={this.state.filterPatientName} onChange={(e) => {
                                                    this.setState({
                                                        filterPatientName: e.target.value
                                                    })
                                                }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'Username'.translate(this.props.lang)}</Label>
                                                <Input value={this.state.filterUsername} onChange={(e) => {
                                                    this.setState({
                                                        filterUsername: e.target.value
                                                    })
                                                }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>{'Patient SSN'.translate(this.props.lang)}</Label>
                                                <Input value={this.state.filterPatientSSN} onChange={(e) => {
                                                    this.setState({
                                                        filterPatientSSN: e.target.value
                                                    })
                                                }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <DatePicker
                                                    label={'Start date'.translate(this.props.lang)}
                                                    value={this.state.startDateLogs}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            startDateLogs: e
                                                        }, () => {
                                                            if (new Date(this.state.startDateLogs).getTime() > new Date(this.state.endDateLogs).getTime()) {
                                                                this.setState({
                                                                    endDateLogs: e
                                                                })
                                                            }
                                                        })

                                                    }} />
                                            </FormGroup>
                                            <FormGroup>
                                                <DatePicker
                                                    label={'End date'.translate(this.props.lang)}
                                                    value={this.state.endDateLogs}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            endDateLogs: e
                                                        }, () => {
                                                            if (new Date(this.state.startDateLogs).getTime() > new Date(this.state.endDateLogs).getTime()) {
                                                                this.setState({
                                                                    startDateLogs: e
                                                                })
                                                            }
                                                        })

                                                    }} />
                                            </FormGroup>
                                        </div>
                                        <FormGroup>
                                            <Button color='primary' onClick={() => {
                                                // componentDidUpdate will handle the get with new params, we just need to update the page to 0 to reset pagination to first page on new search
                                                this.updateParams('page', 0);
                                                // this.get();
                                            }}>{'Search'.translate(this.props.lang)}</Button>
                                        </FormGroup>
                                    </div>
                                }
                                fields={[
                                    {
                                        type: 'text',
                                        name: 'doctorName',
                                        label: 'Doctor'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'username',
                                        label: 'Username'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'patientName',
                                        label: 'Patient'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'patientSSN',
                                        label: 'Social security number'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'modelName',
                                        label: 'Entity type'.translate(this.props.lang),
                                    },
                                    {
                                        type: 'text',
                                        name: 'type',
                                        label: 'Action'.translate(this.props.lang)
                                    },
                                    {
                                        type: 'text',
                                        name: 'reason',
                                        label: 'Consent'.translate(this.props.lang)
                                    },
                                    {
                                        type: 'date',
                                        name: 'createdAt',
                                        label: 'Date'.translate(this.props.lang)
                                    },
                                    {
                                        type: 'text',
                                        name: 'requestIp',
                                        label: 'Ip'.translate(this.props.lang)
                                    },

                                ]}
                                items={this.state.journalNotes.map((item) => {
                                    return {
                                        ...item,
                                        reason: item?.consent?.reason ? item?.consent?.reason : item?.consent?.isUrgent ? 'Urgent'.translate(this.props.lang) : 'N/A',
                                        modelName: humanReadable[item?.item?.modelName] || 'N/A',
                                        ip: item?.ip || 'N/A',
                                        doctorName: item?.user?.name || 'N/A',
                                        username: item?.user?.username || 'N/A',
                                        patientName: item?.item?.patientName || 'N/A',
                                        patientSSN: item?.item?.patientSSN || 'N/A',
                                    };
                                })}
                                rawItems={this.state.items}
                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>



                        </div>
                    </Row>


                </Container>
                {
                    this.state.exportModal ?
                        <Modal centered isOpen={this.state.exportModal}>
                            <ModalHeader style={{ margin: 'auto' }}>{'Export'.translate(this.props.lang)}</ModalHeader>
                            <ModalBody>

                                <FormGroup className='all-cases-important-export-text' >
                                    <Label>{'Important!'.translate(this.props.lang)}</Label>
                                    <p>
                                        {'The export file will be downloaded and stored locally on your device. Please make sure to handle the data responsibly and delete the file once it is no longer required'.translate(this.props.lang)}
                                    </p>
                                </FormGroup>
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button disabled={this.state.loadingExport ? true : false} color="primary" style={{ margin: 10 }} onClick={() => {
                                    this.exportConsentLogs();
                                }}>{'Export'.translate(this.props.lang)}</Button>

                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ exportModal: null })

                                }>{'Close'.translate(this.props.lang)}</Button>

                            </ModalFooter>
                        </Modal>
                        :
                        null

                }
                {
                    this.state.exportFileData ?
                        <InfoModal
                            isOpen={this.state.exportFileData?._id}
                            toggle={() => this.setState({ exportFileData: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.exportFileData?.message}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.props[0].history.push({ pathname: '/my-data/clinic-statistics', state: { selectedEhrExport: this.state.exportFileData?._id } })
                                }}>{'Go to Group statistics'.translate(this.props.lang)}</Button>,
                                <Button color='primary' onClick={() => {
                                    this.setState({ exportFileData: null });
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null
                }
            </div >
        );
    }
}

const selector = formValueSelector('modalForm');

export default connect(state => {
    return { group: selector(state, 'group') }

}, {
    changeSubgroup: value => change("modalForm", "subgroup", value),

})(Page(JournalLogs));
